/**
 * <strong>Properties:</strong><br>
 * <br>
 * <li>{@link module:mw-form/mixins/property/ArrowModeMixin|arrowMode}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DescriptionMixin|description}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/DisabledMixin|disabled}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/HasDynamicMenuMixin|hasDynamicMenu}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/IconMixin|icon}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/IconAlignmentMixin|iconAlignment}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/MenuMixin|menu}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TagMixin|tag}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/TextMixin|text}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/ValidationMixin|validationState, errorText, warningText}</li>
 * <br>
 * <li>{@link module:mw-form/mixins/property/SizeMixin|width, height}</li>
 * <br>
 * <br>
 * <strong>Events:</strong>
 * <br>
 * <br>
 * <li>dropdownclick</li>
 * <br>
 * <br>
 * <strong>Example:</strong>
 * <br>
 * <br>
 * For a working example, see the {@link http://inside-files/dev/eps/WIT/WebWidgets/Gallery/Gallery/|gallery}
 * <br>
 * <br>
 * @module mw-form/SplitButton
 *
 * @copyright Copyright 2015-2019 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "dojo/on",

    "dijit/_WidgetBase",
    "dijit/_Contained",
    "dijit/_FocusMixin",
    "dijit/_TemplatedMixin",

    "mw-form/mixins/property/TagMixin",
    "mw-form/mixins/property/MenuMixin",
    "mw-form/mixins/property/HasDynamicMenuMixin",
    "mw-form/mixins/property/DescriptionMixin",
    "mw-form/mixins/property/DisabledMixin",
    "mw-form/mixins/property/IconAlignmentMixin",
    "mw-form/mixins/property/IconMixin",
    "mw-form/mixins/property/ArrowModeMixin",
    "mw-form/mixins/property/SizeMixin",
    "mw-form/mixins/property/TabIndexNodesMixin",
    "mw-form/mixins/property/TextMixin",
    "mw-form/mixins/property/VisualFamilyMixin",
    "mw-form/mixins/property/ValidationMixin",

    "mw-form/mixins/AccessibilityClickMixin",
    "mw-form/mixins/SplitTypeButtonsAriaLabelledByMixin",
    "mw-form/mixins/PreventSelectionMixin",
    "mw-form/mixins/ResizeMixin",
    "mw-form/mixins/property/DropDownButtonIconAlignmentMixin",
    "mw-form/mixins/property/DropDownButtonArrowModeMixin",
    "mw-form/mixins/property/DropDownButtonTextMixin",
    "mw-form/mixins/property/DropDownButtonSizeMixin",
    "mw-form/mixins/property/DropDownNeverDisabledMixin",
    "mw-form/mixins/SplitButtonToggleSplitButtonMenuMixin",
    "mw-form/mixins/SplitButtonToggleSplitButtonFocusMixin",
    "mw-form/mixins/SplitButtonToggleSplitButtonDescriptionMixin",

    "mw-form/mixins/mixinDependencyValidator",

    "dojo/text!mw-form/templates/DropDownButton.html"
], function (declare, on, _WidgetBase, _Contained, _FocusMixin, _TemplatedMixin, TagMixin, MenuMixin, HasDynamicMenuMixin,
             DescriptionMixin, DisabledMixin, IconAlignmentMixin, IconMixin, ArrowModeMixin, SizeMixin, TabIndexNodesMixin,
             TextMixin, VisualFamilyMixin, ValidationMixin, AccessibilityClickMixin, SplitTypeButtonsAriaLabelledByMixin,
             PreventSelectionMixin, ResizeMixin, DropDownButtonIconAlignmentMixin, DropDownButtonArrowModeMixin,
             DropDownButtonTextMixin, DropDownButtonSizeMixin, DropDownNeverDisabledMixin, SplitButtonToggleSplitButtonMenuMixin,
             SplitButtonToggleSplitButtonFocusMixin, SplitButtonToggleSplitButtonDescriptionMixin, mixinDependencyValidator,
             template) {

    return declare(mixinDependencyValidator.validate([_WidgetBase, _Contained, _FocusMixin, _TemplatedMixin, TagMixin,
        MenuMixin, HasDynamicMenuMixin, DescriptionMixin, DisabledMixin, IconAlignmentMixin, IconMixin, ArrowModeMixin,
        SizeMixin, TabIndexNodesMixin, TextMixin, VisualFamilyMixin, ValidationMixin, AccessibilityClickMixin,
        SplitTypeButtonsAriaLabelledByMixin, PreventSelectionMixin, ResizeMixin, DropDownButtonIconAlignmentMixin,
        DropDownButtonArrowModeMixin, DropDownButtonTextMixin, DropDownButtonSizeMixin, DropDownNeverDisabledMixin,
        SplitButtonToggleSplitButtonMenuMixin, SplitButtonToggleSplitButtonFocusMixin, SplitButtonToggleSplitButtonDescriptionMixin]), {

        baseClass: "mwWidget mwSplitButton",
        templateString: template,

        buildRendering: function () {
            this.inherited(arguments);

            // g1900254: If the user clicks on the border (domNode) directly, then we don't want to respond
            this.domNode.addEventListener("click", function (e) {
                if ((e.target === this.domNode)) {
                    e.preventDefault();
                    e.stopImmediatePropagation();

                    // Clicking on the border should close the menu
                    if (this.isMenuOpen()) {
                        this.closeMenu();
                    }
                }
            }.bind(this), true);
        },

        cssStateNodes: {
            "buttonNode": "mwButtonNode",
            "dropDownNode": "mwDropDownNode"
        },

        _qeClick: function () {
            // g1900254: Emit the click event from the button node
            on.emit(this.buttonNode, "click", {bubbles: true, cancelable: true, detail: {widget: this}});
        }
    });
});